import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { C, FONT, labelSx } from "../accountStyles";



export function AccountSection({ id, title, description, children, first = false }) {
  return (
    <Box
      component="section"
      aria-labelledby={id}
      sx={{
        py: { xs: 4, md: 6 },
        borderTop: first ? "none" : `1px solid ${C.line}`,
        pt: first ? { xs: 1, md: 2 } : undefined,
      }}
    >
      <Grid container spacing={{ xs: 2.5, md: 6 }}>
        <Grid item xs={12} md={4}>
          <Typography id={id} component="h2" sx={{ fontFamily: FONT, fontWeight: 400, fontSize: { xs: "1.35rem", md: "1.6rem" }, color: C.ink, lineHeight: 1.25 }}>
            {title}
          </Typography>
          {description && (
            <Typography sx={{ fontFamily: FONT, color: C.secondary, fontSize: "0.95rem", lineHeight: 1.6, mt: 1, maxWidth: 320 }}>
              {description}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={8}>
          {children}
        </Grid>
      </Grid>
    </Box>
  );
}

export function SectionHeader({ id, title, description, count, actions, as = "h2" }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "stretch", md: "flex-end" },
        justifyContent: "space-between",
        gap: 2.5,
        pb: 2.5,
        mb: { xs: 3, md: 4 },
        borderBottom: `1px solid ${C.ink}`,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1.5, flexWrap: "wrap" }}>
          <Typography id={id} component={as} sx={{ fontFamily: FONT, fontWeight: 400, fontSize: { xs: "1.5rem", md: "1.85rem" }, color: C.ink, lineHeight: 1.2 }}>
            {title}
          </Typography>
          {typeof count === "number" && (
            <Typography component="span" sx={{ ...labelSx, color: C.secondary, fontWeight: 400 }}>
              {count}
            </Typography>
          )}
        </Box>
        {description && (
          <Typography sx={{ fontFamily: FONT, color: C.secondary, fontSize: "0.95rem", lineHeight: 1.55, mt: 0.75 }}>
            {description}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", gap: 1.5 }}>{actions}</Box>}
    </Box>
  );
}
